/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Lock_Aria_LabelInputs */

const en_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Lock`)
};

const fr_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillage de la Video`)
};

const de_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videosperre`)
};

const it_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco video`)
};

const ru_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеоблокировка`)
};

const es_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueo de vídeo`)
};

const zh_cn2_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频锁`)
};

const ja_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオロック`)
};

const hi_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो लॉक`)
};

const pt_pt2_player_video_lock_aria_label = /** @type {(inputs: Player_Video_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio de vídeo`)
};

/**
* | output |
* | --- |
* | "Video Lock" |
*
* @param {Player_Video_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_lock_aria_label = /** @type {((inputs?: Player_Video_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_video_lock_aria_label(inputs)
	if (locale === "de") return de_player_video_lock_aria_label(inputs)
	if (locale === "it") return it_player_video_lock_aria_label(inputs)
	if (locale === "ru") return ru_player_video_lock_aria_label(inputs)
	if (locale === "es") return es_player_video_lock_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_video_lock_aria_label(inputs)
	if (locale === "ja") return ja_player_video_lock_aria_label(inputs)
	if (locale === "hi") return hi_player_video_lock_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_video_lock_aria_label(inputs)
	return en_player_video_lock_aria_label(inputs)
});